import * as googleMapsActions from '../actions/google-maps.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  isReady: boolean;
}

export const initialState: State = {
  isReady: false,
};

const featureReducer = createReducer(
  initialState,
  on(googleMapsActions.googleMapsReady, (state) => ({
    ...state,
    isReady: true,
  }))
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
